import { render, staticRenderFns } from "./InvoiceRefunded.vue?vue&type=template&id=2a60afe2"
import script from "./InvoiceRefunded.vue?vue&type=script&lang=js"
export * from "./InvoiceRefunded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports